import React from 'react';
import { useWtrSelector } from 'redux/hooks';
import { getProductByLineNumber } from 'redux/modules/entities/selectors/products';
import Thumbnail from 'components/Images/Thumbnail';

interface LineItemProps {
  lineNumber: string;
}

const LineItem = ({ lineNumber }: LineItemProps) => {
  // @ts-expect-error entities state is not typed
  const Product = useWtrSelector(state => getProductByLineNumber(state, lineNumber));

  return (
    <Thumbnail
      itemId={Product.lineNumber}
      name={Product.name}
      imgSize={88}
      tooltipTrigger
      data-testid="builder-line-thumbnail"
    />
  );
};

export default LineItem;
